import LinkType from './LinkType';

export interface Link {
  href: string;
  text?: string;
  type: LinkType;
  customTitle?: string;
}

export const EmployerAgents = {
  name: 'For Employer Agent',
  phoneNumber: '888-464-4218',
  textNumber: '877-875-6028 TTY*',
  emailAddress: {
    href: 'E-Verifyemployeragent@uscis.dhs.gov',
    type: LinkType.EMAIL,
  } as Link,
};

export const Employers = {
  name: 'For Employers',
  phoneNumber: '888-464-4218',
  textNumber: '877-875-6028 TTY*',
  emailAddress: {
    href: 'E-Verify@uscis.dhs.gov',
    type: LinkType.EMAIL,
  } as Link,
};

export const Employees = {
  name: 'For Employees',
  phoneNumber: '888-897-7781',
  textNumber: '877-875-6028 TTY*',
  emailAddress: {
    href: 'E-Verify@uscis.dhs.gov',
    type: LinkType.EMAIL,
  } as Link,
};

export const EmployerHotline = {
  name: 'Employer Hotline',
  phoneNumber: '800-255-8155',
  textNumber: '202-616-5525 TTY*',
};

export const EmployeeHotline = {
  name: 'Employee Hotline',
  phoneNumber: '800-255-7688',
  textNumber: '202-616-5525 TTY*',
};

export const Website = {
  name: 'Website',
  website: {
    href: 'http://www.justice.gov/IER',
    type: LinkType.ARTICLE,
    text: 'www.justice.gov/IER',
    customTitle: 'The Immigrant and Employee Rights Section (IER)',
  } as Link,
};
